'use client';

import { useTranslation } from 'react-i18next';
// Its own entry: the illustration's asset map stays out of the web barrel.
import { CharacterIllustration } from '@galapagos/design-system/character-illustration.web';
import { Button } from '@galapagos/design-system/web';
import { FormActions } from '../../components/FormActions';
import { PageTitle } from '../../components/PageTitle';
import { ensureSignupStepStyle } from '../../components/signup-step-style';
import { useSignupNavigation } from '../../hooks/useSignupNavigation';
import { useStepHeading } from '../../hooks/useStepHeading';
import { ensureSignupOffPathStyle } from './off-path-style';

/**
 * Production's "Something went wrong" body (Figma 1:494): heading, the
 * ice-cream illustration on a cream panel, one paragraph and one Book a call
 * button. No back, retry or continue: production's error screen has none.
 * Rendered inside a page's `SignupShell`, so another off-path page can show
 * the same body under its own screen id. The button's action id is fixed;
 * analytics tells the pages apart by the screen id every action carries.
 */
export function SignupErrorContent() {
  const { t } = useTranslation('signup');
  const { goToBookACall } = useSignupNavigation();
  const title = t('error.title');
  const headingRef = useStepHeading(title);
  ensureSignupStepStyle();
  ensureSignupOffPathStyle();
  return (
    <div className="signup-step">
      <PageTitle title={title} headingRef={headingRef} />
      <div className="signup-off-path__panel" data-testid="signup-error-illustration">
        <CharacterIllustration name="ice-cream-fail" size="SM" />
      </div>
      <p className="signup-off-path__body" data-testid="signup-error-body">
        {t('error.body')}
      </p>
      <FormActions>
        <Button
          size="L"
          type="Primary"
          label={t('error.bookCall')}
          onPress={goToBookACall}
          actionId="signup.error-screen-book-call.activate"
          data-testid="signup-error-book-call"
        />
      </FormActions>
    </div>
  );
}
